var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYtLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 .076C13.56.076 5.201 1.69 5.201 1.69l-.02.024C2.246 2.183 0 4.704 0 7.768v18.465A6.154 6.154 0 0 0 5.195 32.3l.006.009S13.56 33.925 20 33.925s14.799-1.616 14.799-1.616l.003-.003A6.154 6.154 0 0 0 40 26.233V7.769a6.154 6.154 0 0 0-5.195-6.07l-.006-.01S26.44.077 20 .077M15.385 9.92 27.692 17l-12.307 7.079z"
})));
export default SvgYtLogo;